import { useMemo } from 'react';
import { SidebarMenuBadge } from '@/components/ui/sidebar';
import { usePermission } from '@/hooks/usePermission';
import { useAuthStore } from '@/stores/authStore';
import { EMPTY_FILTERS, filterTasks } from '@/pages/tasks/board-filters';
import { useTaskBoard } from './useTasks';

/**
 * My open tasks (assigned to me, or mine with no one assigned; not done), beside the Tasks nav
 * link. Uses the same cached Board as the Tasks page, so it moves the moment a task does.
 */
export function TasksNavBadge() {
  const canView = usePermission('TASKS');
  const me = useAuthStore((s) => s.user?.id);
  const { board } = useTaskBoard({}, canView);

  const count = useMemo(() => {
    if (!board) return 0;
    const done = new Set(board.columns.filter((c) => c.is_done).map((c) => c.id));
    return filterTasks(board.tasks, { ...EMPTY_FILTERS, mine: true }, me).filter((t) => !done.has(t.column_id)).length;
  }, [board, me]);

  if (!canView || !count) return null;
  return (
    <SidebarMenuBadge className="text-muted-foreground" data-hint="Your open tasks" aria-label={`${count} open tasks for you`}>
      {count}
    </SidebarMenuBadge>
  );
}
